<template>
  <div class="controlOrder">
    <div class="title">设置集团公司招标办审签单信息</div>
    <el-form
      ref="ruleForm"
      :model="formData"
      label-width="130px"
      :inline="true"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="标题" prop="signTableName">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="日期">
            <el-date-picker
              v-model="formData.approveTime"
              type="date"
              placeholder="请选择日期"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称">
            <el-input v-model="formData.projectName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提报单位/部门">
            <el-input v-model="formData.commitDeptName" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="采购计划事项">
            <el-input v-model="formData.bidPlanItem" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="采购计划编号" prop="controlPriceId">
            <el-input v-model="formData.bidPlanCode" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目类别">
            <el-input v-model="formData.projectType" readonly></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="采购金额">
            <el-input v-model="formData.estimatePrice" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="采购方式：">
            <el-input v-model="formData.bidPlanMethodValue" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否已取得决策依据">
            <el-input
              v-model="formData.decisionBaseDisplayName"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="提报单位负责人">
            <el-input
              v-model="formData.commitResponseUserName"
              placeholder="请选择提报单位负责人"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经办人">
            <el-input
              v-model="formData.handlingUserName"
              placeholder="请选择经办人"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="项目情况" prop="approveComment">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              v-model="formData.projectState"
              style="width: 100%"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
        <div class="title">审批人及打印设置</div>

        <template v-for="(item, index) in formData.approveInfoList">
          <el-row :key="item.id" class="approveItem">
            <!-- <el-col :span="4">
            <el-form-item
              v-if="index == 0"
              label="参会部门及其负责人"
              prop="serialNumber"
            >
            </el-form-item>
            <el-form-item v-else label="" prop="serialNumber"> </el-form-item>
          </el-col> -->
            <el-col :span="8">
              <el-form-item
                :label="`审批人${index + 1}`"
                label-width="130px"
                prop="serialNumber"
              >
                <el-input v-model="item.approveUserName" readonly=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="margin-left: 10px">
              <el-form-item label="" label-width="10px">
                <el-input v-model="item.jobName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <div class="checkboxWrap">
                <el-checkbox
                  v-model="item.isPrint"
                  style="width: 40px"
                  label="1"
                  >打印
                </el-checkbox>
              </div>
            </el-col>
            <!-- <el-col :span="6" style="margin-left: 10px">
            <el-form-item label="" label-width="10px" style="width:100%">
              <el-select
                        v-model="item.isLeaderOpinion"
                        default-first-option
                        placeholder="请选择"
                      >
                        <el-option
                          label="定额工作小组成员意见"
                          value="1"
                        ></el-option>
                        <el-option
                          label="定额工作小组副组长意见"
                          value="2"
                        ></el-option>
                        <el-option
                          label="定额工作小组组长意见"
                          value="3"
                        ></el-option>
                      </el-select>
            </el-form-item>
          </el-col> -->
            <!-- <el-col :span="4" style="margin-top: 24px">
            <div class="checkboxWrap">
              <el-checkbox
                v-model="item.isLeaderOpinion"
                style="width: 40px"
                label="1"
                >集团分管领导意见
              </el-checkbox>
            </div>
          </el-col> -->
          </el-row>
        </template>
  
    </el-form>
    <div class="bottomBtn">
      <el-button type="primary" @click="print">打印预览</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
    <filePrint
      :visible.sync="printVisible"
      :printData="formData"
      v-if="printVisible"
    >
    </filePrint>
  </div>
</template>

<script>
import {
  getBidFiledetail, //获取一条采购计划信息
  updatefilePricePrint,
} from "@/services/bidServices";
import {
  queryRealApproveProcessSign, //获取打印页面带签名审批详情
} from "@/services/approveServices";
import {  getsignUrlApi} from "@/services/sysSettingService";
import ApplyUserDialog from "@/page/contract/commonCell/ApplyUserDialog";
import filePrint from "./fileOrderPrint";
// import DeptSelectComponent from "./DeptSelectComponent";
// import PrintDeptSelectComponent from "./PrintDeptSelectComponent";

export default {
  name: "controlOrder",
  props: {
    itemId: {
      type: Number,
    },
    approveType: {
      type: String,
    },
  },
  components: {
    ApplyUserDialog,
    filePrint,
    // DeptSelectComponent,
    // PrintDeptSelectComponent,
  },
  data() {
    return {
      formData: {
        title: "集团公司招标办审签单",
        approveTime: new Date(),
      },
      printVisible: false,
    };
  },
  watch: {
    itemId: {
      handler: function (newVal) {
        if (newVal) {
          this.getDetail(this.itemId);
        }
      },
      immediate: true,
    },
  },
  methods: {
    //获取一条会议提报单信息
    getDetail(id) {
      getBidFiledetail({ bidFileId: id })
        .then((res) => {
          if (res.code == 10000000) {
            const data = res.data || {};
            data.title = data.title ?? "集团公招标办审签单";
            data.approveTime = data.approveTime ?? new Date();
            
            if (!res.data.approveInfoList) {
              queryRealApproveProcessSign({
                itemId: id,
                approveClass: "BID_FILE",
              }).then((res1) => {
                if (res1.code == 10000000) {
                  let approveInfoList = res1.data || [];
                  if (approveInfoList.length > 0) {
                    approveInfoList = approveInfoList.map(
                      (item) => {
                        item.isPrint = true;
                        return item;
                      }
                    );
                    this.formData = {
                      ...data,
                      approveInfoList
                    }
                    // this.formData.approveInfoList=[]
                    // this.formData.approveInfoList=[...approveInfoList]
                  }
                }
              });
            } else {
              this.formData = {
                      ...data,
                      approveInfoList:data.approveInfoList
                    }
              // this.formData.approveInfoList = data?.approveInfoList || [];
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    submit() {
      let newOj = {
        approveTime: this.formData.approveTime,
        bidFileId: this.itemId,
        title: this.formData.title,
      };
      newOj.approveInfoList = this.formData.approveInfoList;
      updatefilePricePrint({
        ...newOj,
      })
        .then((res) => {
          if (res.code == 10000000) {
            this.$alert("保存成功", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert(res.msg, "确定");
          }
        })
        .catch((err) => {
          this.$message.error("网络请求失败");
        });
    },
     //获取审批人签名
     getsignUrlFun() {
      let reqParam = {
        signUserIdSet: this.formData.approveInfoList.map(item=>item.approveUserId).join(','),
      };
      getsignUrlApi(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            let urls=res.data
            this.formData.approveInfoList.forEach(em => {
              let s=urls.find(item=>item.userId==em.approveUserId)
              em.approveUserNameSignUrl=s.signUrl
              return em
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    async print() {
      await this.getsignUrlFun()
      this.printVisible = true;
      this.$emit("handlePrint", {
        formData: this.formData,
        approveList: this.approveList,
      });
    },
    showApplyUserDia(type) {
      this.applyUserDiaType = type;
      this.applyUserDiaVisible = true;
    },
    closeDialog() {
      this.applyUserDiaVisible = false;
    },
    //部门数据改变时更新数据
    handleChangeDept(value) {
      this.formData.handleDeptId = value[value.length - 1];
      let labels = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels;
      this.formData.handleDeptName = labels[labels.length - 1];
    },
    handleChangeDeptCom(e, index) {
      this.$set(this.formData.approveInfoList[index], "deptKey", e.value);
      this.$set(this.formData.approveInfoList[index], "deptKeyName", e.label);
    },
    //存储申请人
    saveApplyUser(selectItems) {
      this.formData.contactUserName = selectItems.applyUserName;
      this.formData.contactUserId = selectItems.applyUserId;
      this.formData.contactUserPhone = selectItems.phone;

      this.applyUserDiaType = "";
      this.applyUserDiaVisible = false;
    },
    updateValue(val) {
      this.formData.contactUserPhone = val;
      this.$forceUpdate();
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.controlOrder {
  margin-bottom: 30px;
  .title {
    margin: 10px 0;
    font-weight: bold;
  }

  .marginLeft8 {
    margin-top: 18px;
    margin-left: 4px;
  }

  .checkboxWrap {
    width: 110px - 12px;
    text-align: left;
    margin-left: 10px;
  }

  .bottomBtn {
    z-index: 100;
    left: 660px;
    position: fixed;
    bottom: 20px;
    height: 40px;
    line-height: 40px;
  }
}

/deep/ .el-form-item__content {
  width: 100%;
  .el-input {
    width: 100%;
  }
}
</style>
